<template>
  <v-container
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
      >
        <v-dialog
          v-model="dialogVisible"
          width="clamp(350px, 50%, 50%)"
          persistent
        >
          <v-card>
            <v-card-title class="display-3">
              Профиль участника
            </v-card-title>
            <v-divider />
            <v-tabs
              v-model="currentTab"
              show-arrows
            >
              <v-tab>Профиль</v-tab>
              <v-tab @change="onChangeTab">
                Лояльность
              </v-tab>
              <v-tab>Пароль</v-tab>
              <v-tab-item :eager="true">
                <v-form
                  ref="uform"
                  v-model="validUserData"
                >
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          v-model="userProfile.name"
                          outlined
                          prepend-inner-icon="mdi-account"
                          :rules="[
                            () => !!userProfile.name || 'Поле требует заполнения',
                          ]"
                          label="Имя"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          v-model="userProfile.surname"
                          outlined
                          prepend-inner-icon="mdi-account-plus"
                          :label="'Фамилия'"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <!--                  :v-model="userProfile.phone | vMask('# (###) ##-###-##')"-->
                        <v-text-field
                          v-mask="'+#(###)##-###-##'"
                          outlined
                          prepend-inner-icon="mdi-phone-classic"
                          :value="userProfile.login"
                          hint="формат - +# (###) ##-###-##"
                          label="Телефон "
                          placeholder="+# (###) ##-###-##"
                          :rules="[
                            () => !!userProfile.login || 'Поле требует заполнения',
                          ]"
                          @input="(value) => (userProfile.login = value)"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          v-model="userProfile.email"
                          outlined
                          prepend-inner-icon="mdi-email"
                          label="Эл. почта"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
                <v-divider />
                <v-card-actions v-if="!isCreating">
                  <v-row
                    align-content="space-between"
                    justify="space-around"
                  >
                    <v-btn
                      color="primary"
                      @click="onSave()"
                    >
                      Сохранить
                    </v-btn>
                    <v-btn
                      color="primary"
                      outlined
                      @click="onClose"
                    >
                      Закрыть
                    </v-btn>
                  </v-row>
                </v-card-actions>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-card>
                  <user-profile-form
                    v-model="attrSaved"
                    :customer-id="customerId"
                    :user-profile-id="userProfile.userProfileId"
                    @fill="onAllFieldFilled"
                    @validate="onValidate"
                  />
                  <v-card-actions
                    v-if="!isCreating"
                    class="d-flex justify-center"
                  >
                    <v-btn
                      :disabled="!isLoyaltyFormValidated"
                      color="primary"
                      @click="onSaveLoyalty"
                    >
                      Сохранить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card>
                  <v-form
                    ref="form"
                    v-model="validChangePassword"
                  >
                    <v-card-text>
                      <v-row class="d-flex flex-column justify-center align-center">
                        <v-col cols="6">
                          <v-text-field
                            v-model="form.password"
                            outlined
                            label="Новый пароль"
                            :rules="passwordRules"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPassword ? 'text' : 'password'"
                            @click:append="showPassword = !showPassword"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="form.password2"
                            outlined
                            label="Повторить"
                            :rules="passwordRules"
                            :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPassword2 ? 'text' : 'password'"
                            @click:append="showPassword2 = !showPassword2"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions
                      v-if="!isCreating"
                      class="d-flex justify-center"
                    >
                      <v-btn
                        color="primary"
                        :disabled="!validChangePassword || form.password !== form.password2"
                        @click="onChangePassword"
                      >
                        Сменить
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-card-text v-if="isCreating">
              <v-row
                v-if="alertCreating.show"
                class="text-center"
              >
                <v-col
                  cols="12"
                >
                  <div
                    style="color: red;"
                  >
                    {{ alertCreating.error }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions v-if="isCreating">
              <v-row
                align-content="space-between"
                justify="space-around"
              >
                <v-btn
                  color="primary"
                  :disabled="!validUserData || !validChangePassword || form.password !== form.password2"
                  @click="onCreate()"
                >
                  Создать
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="onClose"
                >
                  Закрыть
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from "../../shared/components/date-picker/DatePicker"
import WebApi from "../../shared/modules/web_api"
import { UserProfileModel } from "../../models/user-profile.model"
import ParticipantList from "../participant/ParticipantList"
import { TheMask } from "vue-the-mask"
import UserProfileForm from "@/views/loyalty/components/user_profile/UserProfileForm"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import { LoginService } from "@/views/loyalty/shared/services/login-service"

export default {
  name: "UserProfileCreate",
  components: {
      DatePicker,
      ParticipantList,
    UserProfileForm,
    TheMask
  },
    props: {
customerId: {
      default: null,
},
customerNumber: { default: null },
dialogVisible: { default: null },
isCreating: { default: false },
userProfile: { default: new UserProfileModel() }
},
  data: () => ({
      alertCreating: {
          show: false,
          error: '',
      },
    attrSaved: false,
    currentTab: 0,
    isLoyaltyFormValidated: false,
    errorOldPassword: false,
    errorMessageOldPassword: [],
    isAllFieldFilled: false,
    form: {
      password: '',
      password2: ''
    },
      loginService: null,
    role: 0,
    onSaveAttr: false,
    passwordRules: [
      v => !!v || 'Пароль обязателен',
      v => (v && v.length >= 6) || 'Пароль должен содержать, не менее 6 символов',
    ],
    showPassword: false,
    showPassword2: false,
      userProfileService: null,
    validChangePassword: false,
      validUserData: false,
    webApi: null
  }),
  async beforeMount () {
    // console.clear()
    this.webApi = new WebApi(this.$store)
        .editSuccess("Профиль пользователя сохранен успешно!")
        .editError("Ошибка при сохранении профиля пользователя")
        .readError("Ошибка при загрузке профиля пользователя")
      this.userProfileService = new Userprofile(this.$store)
      this.loginService = new LoginService()
      console.log('userProfile', this.userProfile)
  },
  methods: {
      async onCreate () {
          this.alertCreating.show = false
      console.log(this.userProfile)
      console.log(`this.customerId=${this.customerId}`)
          const login = Object.assign({}, this.userProfile)
          Reflect.set(login, 'password', this.form.password)
          Reflect.set(login, 'password2', this.form.password2)
          Reflect.set(login, 'customerId', this.customerId)
          Reflect.set(login, 'customerNumber', this.customerNumber)
          Reflect.set(login, 'phoneNumber', this.userProfile.login)
          console.log('login', login)
        const userProfile = await this.loginService.createLogin(login)
          console.log('created userProfile', userProfile)
          if (userProfile.data) {
              this.$emit('create')
          } else {
              this.alertCreating.show = true
              this.alertCreating.error = userProfile.error
          }
    },
    onAllFieldFilled (isAllFieldFilled) {
      console.log('isAllFieldFilled', isAllFieldFilled)
      this.isAllFieldFilled = isAllFieldFilled
      // if (isAllFieldFilled) {
      //   this.$router.push({ name: 'Crowd' })
      // }
    },
      onClose () {
        this.$emit('close')
      },
    async onChangePassword () {
        const response = await this.userProfileService.updateUserProfileCreatePassword(this.userProfile.userProfileId, { oldPassword: '', password: this.form.password })
    },
    onChangeTab () {
      if (!this.customerId) {
        this.customerId = localStorage.getItem('customer')
      }
    },
    onValidate (isLoyaltyFormValidated) {
      this.isLoyaltyFormValidated = isLoyaltyFormValidated
    },
    async onSave () {
        const userProfile = await this.userProfileService.updateUserProfile(this.userProfile)
      console.log('userProfile:', userProfile)
      // if (this.userProfile.isAllFieldFilled()) {
      //   if (this.isAllFieldFilled) {
      //     // await this.$router.push({ name: 'Crowd' })
      //   } else {
      //     this.currentTab = 1
      //   }
      // }
    },
    onSaveLoyalty () {
      this.attrSaved = true
      // TODO There is error happened
      if (this.userProfile.isAllFieldFilled()) {
        // this.$router.push({ name: 'Crowd' })
      } else {
        this.currentTab = 0
      }
    }

  }
  }
</script>

<style scoped></style>
